
document.addEventListener("DOMContentLoaded", function () {
const logo = document.querySelector(".img_logo");
const wrapper = document.querySelector(".logo-wrapper");

let scaleActive = false;

logo.addEventListener("mouseover", () => {
    scaleActive = true;
});

logo.addEventListener("mouseout", () => {
    scaleActive = false;
});

wrapper.addEventListener("mousemove", (e) => {
    const rect = wrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * 45;
    const rotateY = ((x - centerX) / centerX) * 45;

    logo.style.transform = ` rotateX(${-rotateX}deg) rotateY(${rotateY}deg)`;
});

wrapper.addEventListener("mouseleave", () => {
    logo.style.transform = `scale(1.25) rotateX(0deg) rotateY(0deg)`;
});
});

if(scaleActive){
    logo.style.transform = `scale(1.25)`;
} else {
    logo.style.transform = `scale(1)`;
}



